import { createContext } from 'react';
import { UserTutorialDetailPaneState } from '../components/organisms/user_tutorial_completions/states/UserTutorialDetailPaneState';

type UserTutorialCompletionProps = {
  resource: UserTutorialDetailPaneState;
};

export const UserTutorialCompletionContext: React.Context<UserTutorialCompletionProps> =
  createContext<UserTutorialCompletionProps>({
    resource: new UserTutorialDetailPaneState(),
  });
